/**
 * IMPORTS
 */

import { produtosRepository } from "@/repositories/produtos";

/**
 * Função que busca dados de produtos 🛠️.
 */
const handleGetProdutos = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string,
  somenteAtivos = false
) => {
  try {
    const data = await produtosRepository.getAllProdutos(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem,
      somenteAtivos
    );

    return data;
  } catch (error: any) {
    console.log("ERROR EM BUSCAR PRODUTOS: ", error);

    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetProdutos };
